import get from 'lodash/get';
import flow from 'lodash/flow';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import configuratorReducer from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer';
import { getConfigurationModes } from '@configuratorware/configurator-frontendgui/App/Reducers/ConfigurationMode/Selectors';
import { PMS_REGEX } from '../../../../lib/constants';

const initialState = {
  originalConfigurationData: null,
  currentDesignData: null,
  sortedPmsAmounts: null,
  minAmountPms: null,
  surcharges: null,
  maxAmount: null,
  fullTitle: '',
};

export default function customConfiguratorReducer(
  state = initialState,
  action = {},
) {
  switch (action.type) {
    case configuratorActions.RECEIVE_CONFIGURATION: {
      let {
        originalConfigurationData,
        surcharges,
        fullTitle,
        maxAmount,
        minAmountPms,
      } = state;

      if (action.data) {
        if (!originalConfigurationData) {
          originalConfigurationData = action.data;
        }

        if (!surcharges) {
          const { attributes } = action.data.item;
          surcharges = {};

          attributes.forEach((att) => {
            if (att.identifier.includes('fromAmount')) {
              const value = att.values[0];
              const idx = att.identifier.split('_')[1];
              surcharges[idx] = { ...surcharges[idx], from: value };
            } else if (att.identifier.includes('toAmount')) {
              const value = att.values[0];
              const idx = att.identifier.split('_')[1];
              surcharges[idx] = { ...surcharges[idx], to: value };
            } else if (att.identifier.includes('surcharge_')) {
              const value = att.values[0];
              const idx = att.identifier.split('_')[1];
              surcharges[idx] = {
                ...surcharges[idx],
                value: value.value,
                formattedValue: /* formatter.format */ value.value,
              };
            }
          });
        }

        if (!minAmountPms) {
          const { attributes } = action.data.item;
          minAmountPms = attributes.find(
            (att) => att.identifier.toUpperCase() === 'MINAMOUNTPMS',
          )?.values[0].value || 0;
        }

        if (!fullTitle) {
          const { identifier, title } = action.data.item;
          fullTitle = `${title} (${identifier})`;
        }

        if (!maxAmount) {
          const { attributes } = action.data.item;
          let max = attributes.find(
            (att) => att.identifier.toUpperCase() === 'MAXIMUMAMOUNTTOORDER',
          );

          max = max?.values[0].value;
          if (max) {
            maxAmount = max > 0 ? max : 9999999;
          } else maxAmount = 9999999;
        }
      }

      return {
        ...state,
        originalConfigurationData,
        surcharges,
        fullTitle,
        maxAmount,
        minAmountPms,
      };
    }
    /*  case configuratorActions.RECEIVE_DESIGNER_DATA: {
      console.log('CONFIGURATOR RECEIVE_DESIGNER_DATA', state);
      return {
        ...state,
        //    currentDesignData: action.data,
      };
    }
    case configuratorActions.SET_SELECTED_AMOUNT: {
      console.log('SET SLEECTED AMOUNT', configuratorReducer);
      const nextState = configuratorReducer({}, action);
      console.log('SET SLEECTED AMOUNT', nextState);

      return state;
    } */
    case configuratorActions.RECEIVE_CALCULATION: {
      let { sortedPmsAmounts: sortedAmounts, minAmountPms } = state;
      if (!sortedAmounts) {
        const sortFunc = (a, b) => a - b;
        const positions = get(action, 'data.positions', {});
        sortedAmounts = positions
          .filter((position) => (position.calculationTypeIdentifier || '').match(PMS_REGEX))
          .map((position) => ({
            ...position,
            minAmount: parseFloat(
              position.calculationTypeIdentifier.split(PMS_REGEX)[1],
            ),
          }))
          .sort((position) => sortFunc(position.minAmount));
      }
      console.log({ minAmountPms, sortedAmounts }, minAmountPms && sortedAmounts.length > 0);

      if (minAmountPms && sortedAmounts.length > 0) {
        while (sortedAmounts[0].minAmount < minAmountPms) {
          sortedAmounts.splice(0, 1);
        }
      }
      return {
        ...state,
        sortedPmsAmounts: sortedAmounts,
      };
    }
    default:
      return state;
  }
}
